module.exports = __webpack_public_path__ + "static/media/exercises-step4.d3f8a0d9.png";